import classNames from 'classnames';


import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

const LoadingIcon = ({ className }: Props) => (
  <span className={classNames(styles.loadingIcon, className)} role="status" aria-label="Loading"><span className={styles.ring} aria-hidden="true" /></span>
);

export default LoadingIcon;
